export default __webpack_public_path__ + "static/media/bharat-petroleum.76206941.webp";